module.exports = __webpack_public_path__ + "img/bg09.e8d2cd4c.gif";